"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookieNames = void 0;
const cookieNames = exports.cookieNames = ['mobileApp', 'mobileAppMode', 'mobileAppVersion'];
